/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Box, Button, Typography } from '@mui/material';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import { ReactComponent as LogoDealpumpItalic } from '@/assets/images/dealpump-italic.svg';

export function Fallback() {
  const handleRedirect = () => {
    // eslint-disable-next-line @typescript-eslint/prefer-ts-expect-error
    // @ts-ignore
    window.location = '/';
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        gap: 2,
      }}
    >
      <Box sx={{ pt: 4 }}>
        <LogoDealpumpItalic width={90} height={20} />
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          flex: 1,
          gap: 2,
        }}
      >
        <WarningAmberIcon color="error" fontSize="large" />
        <Typography variant="h5" color="error">
          Something went wrong
        </Typography>
        <Button
          onClick={handleRedirect}
          variant="outlined"
          sx={{ color: 'black', borderColor: 'black' }}
        >
          Try again
        </Button>
      </Box>
    </Box>
  );
}
